// src/Components/Share/shareStore.ts
// Any screen opens the share sheet with openShare(spec); ShareHost (mounted
// once in AppShell) renders it. A plain module like Ui/rewardFlightStore.
import type { ClipSpec } from "./clipModel";

type Listener = (spec: ClipSpec | null) => void;
let current: ClipSpec | null = null;
const listeners = new Set<Listener>();

export function openShare(spec: ClipSpec) {
  current = spec;
  listeners.forEach((l) => l(current));
}

export function closeShare() {
  current = null;
  listeners.forEach((l) => l(null));
}

export function getShare(): ClipSpec | null {
  return current;
}

export function subscribeShare(l: Listener): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}
